<template>
    <div class="root">
      <div class="title">流量套餐</div>
      <div class="balance" v-if="stockInfo.rechargeType==1">
        <span class="text-1">卡积分：</span><span class="text-2"> {{stockInfo.balance}}分</span>
        <span  class="text-3" @click="rechargeBalance">充值</span>
      </div>
      <div class="package-list">
        <template v-if="groupedSections.length>0">
          <div class="package-section" v-for="section in groupedSections" :key="section.type">
            <!--<div class="section-title">{{ section.title }}</div>-->
            <div class="package-group" v-for="group in section.groups" :key="section.type + '-' + group.key">
              <div class="group-title">{{ group.title }}</div>
              <div class="group-grid">
                <div
                  class="package-item"
                  v-for="item in group.items"
                  :key="item.id"
                  :class="{'color1':item.month<12,'color2':item.month==12,'color3':item.month>12}"
                >
                  <div class="head">
                    <div class="package-title">{{ item.title}}</div>
                    <div class="price">
                      <span class="icon">&yen;</span>
                      <span>{{item.price}}</span>
                    </div>
                  </div>
                  <div class="desc">
                    {{item.desc}}
                  </div>
                  <div class="expire">{{ item.startDate }}-{{ item.endDate }}</div>
                  <div class="bottom">
                    <div class="btn" @click="checkPackage(item),createOrder()">立即{{stockInfo.rechargeType==1?'兑换':'订购'}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div v-else class="empty">
          没有可充值的套餐
        </div>
      </div>
      <div class="tips disclaimer">
        <div class="tp-title">免责声明</div>
        <div class="tp-content">
          <div class="xy-heading">购买须知</div>
          1、套餐规则

          1）套餐随用随充，均为全国流量（不含港澳台和运营商指定限制上网区域，目前运营商限制区域包括：新疆全境、西藏全境、云南全境）。

          2）套餐分为基础套餐和定额套餐。基础套餐指按固定周期（月/季/半年/年）订购的流量套餐，周期内每月享有固定流量额度；定额套餐是指套餐有效期内流量总量为固定值的套餐。

          3）当前若无其他有效基础套餐或定额套餐，所购套餐立即生效，购买时间即生效时间。当前仅可有一个基础套餐或定额套餐生效，套餐到期后立即失效。当基础套餐最后一个周期流量用尽且无可用的加油包或定额套餐流量用尽时，若此时订购新的基础套餐或定额套餐，则原套餐失效，新购套餐生效。

          4）购买套餐后须完成实名认证方可使用：购买双网套餐且完成全部实名认证后，则可切换网络使用，若只对其中某一运营商实名认证，则无法切换网络使用；如需切换网络使用，则需对另一运营商实名认证。

          5）由于中国移动管控要求，当月移动网络流量会有40G的用量限制，超出后为您提供中国电信的网络流量，请您务必实名认证并激活电信卡。

          6）根据工信部和基础运营商的政策变化情况，可能对流量套餐价格进行浮动调整。

          7）离网（无有效套餐）180天内可随时启用；离网超过180天，请联系客服确认是否可以重新启用。

          2、基础套餐

          1）套餐有效期：基础套餐中，月包套餐有效期为30个自然日；季包套餐有效期为90个自然日；半年包套餐有效期为180个自然日；年包套餐有效期为360个自然日；套餐有效期自套餐生效次日起计算，以月包套餐为例：2025年6月10日激活使用，月包到期时间为2025年7月10日。

          2）流量结转规则：长周期（每30个自然日为一个周期，简称：期）基础套餐的当期未使用完流量不可结转至次期，即当期未用尽流量将在本期最后一天23:59自动清零。当期流量用尽可自主选购“加油包”继续使用。

          3）加油包：必须依托于一个正在生效中的基础套餐方可购买。加油包的网络类别、覆盖地区等属性均与当前基础套餐相同，购买后立即生效，当期基础套餐到期后，加油包亦同步失效，流量自动清零不可结转。

          4）退订规则：

          ①月包套餐：退订时，已使用流量部分按照1元/G标准收取费用，最高不超过当月套餐购买价格；套餐到期后，不支持退订。

          ②长周期套餐（季包套餐、半年包套餐、年包套餐）：退订时，已使用流量部分按照【使用月数（含当月）*月包套餐价格】的标准收取费用，最高不超过该长周期套餐购买价格；套餐剩余使用期限小于或等于一个月的，不予退款。

          ③退订顺序：基础套餐退订时如有流量未用尽的加油包，则先退订加油包再退订基础套餐。加油包退款规则同月包基础套餐。

          ④退款说明：退款金额为实际支付金额扣除前述应收取费用。若您在支付时选择使用优惠券，则套餐退订时，所使用优惠券（如有）无法退还。

          3、定额套餐

          1）套餐有效期：定额套餐中，半年包套餐有效期为90个自然日，180个自然日，年包套餐有效期为360个自然日；套餐有效期自套餐生效次日起计算，以年包套餐为例：2025年6月10日激活使用，年包到期时间为2026年6月5日。

          2）流量使用规则：套餐有效期内，套餐内流量可自由使用，流量用尽时套餐自动失效。定额套餐不支持加油包的订购，套餐到期后，未使用流量自动清零，不可延期或结转；流量用尽但未到期时，需重新购买流量套餐使用。

          3）退订规则：退订时，已使用的流量部分将按照1元/G的标准收取费用，且所收取的费用最高不超过该流量包的购买价格退款金额为实际支付金额扣除前述应收取费用。套餐到期后，不支持退订。若您在支付时选择使用优惠券，则套餐退订后，所使用优惠券（如有）无法退还。
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: "recharge",
        data() {
            return {
                iccid:'',
                packageID:0,
                //packageList:[],
                packageGroup:[],
                one:{},
                stockInfo:{},
                tips:[],
                operator:{},
                authRecharge:0,
            };
        },
        computed:{
            packages0(){
              return this.packageGroup[0] ? this.packageGroup[0] : []
            },
            groupedSections(){
              const makeGroups = (list) => {
                const filtered = (list || []).filter(i => i)
                if (!filtered.length) return []
                const map = {}
                const order = []
                for (const item of filtered) {
                  const rawKey = (item.typeName && String(item.typeName).trim()) ? String(item.typeName).trim() : '其他套餐'
                  const key = rawKey
                  if (!map[key]) {
                    map[key] = { key, title: rawKey, items: [] }
                    order.push(key)
                  }
                  map[key].items.push(item)
                }
                return order.map(k => map[k])
              }

              const sec0 = makeGroups(this.packages0)
              const sections = []
              if (sec0.length) sections.push({ type: 0, title: '本月流量', groups: sec0 })
              return sections
            },
            hasAnyPackages(){
              return (this.packages0 && this.packages0.length)
            }

        },
        watch:{},
        methods: {
            queryPackageList(type){
                this.$toast.loading()
                this.fetchData('/package/getRechargePackage',{iccid:this.iccid,type:type},(res)=>{
                    this.$toast.clear();
                    if(res.code){
                        this.$set(this.packageGroup ,type,res.data)
                        this.$forceUpdate()
                    }else{
                        this.packageGroup[type]=[]
                    }
                })
            },
            checkPackage(item){
                this.packageID = item.id
                this.one = item;
            },
        createOrder(){
                if(this.authRecharge == 0){
                    this.$toast('请实名后再续费,若已实名，请尝试刷新网页重试');
                    return false;
                }
                if(this.type == 0 && this.one.alertMsg){
                  this.$dialog.confirm({
                    title: '提示',
                    message: this.one.alertMsg
                  }).then(() => {
                    if(this.stockInfo.rechargeType==1) {
                        this.commitorderbalance()
                      }else {
                          this.commitorder()
                      }
                  }).catch(() => {
                    // on cancel
                  });
                }else{
                  if(this.stockInfo.rechargeType==1) {
                        this.commitorderbalance()
                      }else {
                          this.commitorder()
                      }
                }
            },
          commitorder(){
            this.$toast.loading({ forbidClick: true })
            this.fetchDataPost('/order/createOrder',{iccid:this.iccid,packageID:this.packageID,type:this.type},(res)=>{
              this.$toast.clear();
              if(res.code){
                WeixinJSBridge.invoke(
                  'getBrandWCPayRequest', res.data,
                  (res)=>{
                    if(res.err_msg == "get_brand_wcpay_request:ok" ) {
                      this.$toast.success('支付成功');
                      this.$router.push({name:'index',query:{iccid:this.iccid}})
                    }
                  }
                );
              }else{


                if(res.url){
                  if(res.msg) {
                    this.$dialog.confirm({
                      title: "提示",
                      message: res.msg
                    }).then(() => {
                      // on confirm
                      let query = {}
                      if (res.data) {
                        query = res.data
                      }
                      query.cardno = this.iccid
                      sessionStorage.removeItem('token');
                      this.$router.push({path: res.url, query: query})
                    }).catch(() => {
                      // on cancel
                    })
                  }else{
                    this.$router.push({path: res.url, query: res.data})
                  }
                }else {
                  if (res.msg.indexOf('appid') !== -1 && res.msg.indexOf('openid') !== -1) {
                    this.$toast.fail('登录失效，请尝试重新进入查询')
                    sessionStorage.clear()
                  } else {
                    this.$dialog.alert({
                      title: '提示',
                      message: res.msg,
                    }).then(() => {

                    });

                  }
                }


              }
            })
          },
	  commitorderbalance(){
      this.$toast.loading({ forbidClick: true })
                this.fetchDataPost('/order/createOrderbalance',{iccid:this.iccid,packageID:this.packageID,type:this.type},(res)=>{
                    this.$toast.clear();
                    if(res.code){
                        this.$toast.success(res.msg)
                        setTimeout(res=>{
                            this.$router.back()
                        },1500)
                    }else{
                        this.$toast(res.msg)
                        if(res.msg && res.msg.indexOf("积分") !== -1){
                            setTimeout(res=>{
                                this.rechargeBalance()
                            },1500)

                        }
                    }

                })
            },
            rechargeBalance(){
                this.$router.push({name:"cardBalance",query: {iccid:this.iccid}})
            },

            getStockInfo(){
                this.fetchData('/card/info',{iccid:this.iccid},(res)=>{
                    this.stockInfo = res.data
                    if(this.stockInfo.amount > 0){
                        this.type = 1
                    }
                })
            },
            getTips(){
                this.fetchData('/card/tips',{iccid:this.iccid},(res)=>{
                    console.log(res.data)
                    this.tips = res.data.split("\n")
                })
            },
            getCardOperator(){
                this.fetchData('/card/cardOperator', {iccid: this.iccid}, (res) => {
                    if (res.code) {
                        this.operator = res.data
                        if(this.operator.activeRule == 1){
                            this.fetchData('/card/status', {iccid: this.iccid}, (res) => {
                              console.log(res.data)
                                if (!res.data.simAuthStatus) {
                                    this.$dialog.alert({
                                        title: '实名提示',
                                        message: '请先完成实名',
                                    }).then(() => {
                                        // on close
                                        window.location.href = this.operator.authUrl
                                    });
                                }else{
                                    this.authRecharge = 1
                                }
                            })
                        }else{
                            this.authRecharge = 1
                        }
                    }
                })
            }
        },
        created: function () {
            let query = this.$route.query;
            this.iccid = query.iccid;
            this.getStockInfo()
            this.getCardOperator();
            // 只拉取本月套餐
            this.queryPackageList(0)
            this.getTips()
        }
    };
</script>
<style lang="scss" scoped>
.root{
  .tips{
    width: 6.9rem;
    margin: .4rem auto;
    color: #fff;
    .tp-title{
      font-size: .32rem;
    }
    .tp-content{
      margin-top: .26rem;
      margin-left: .32rem;
      line-height: 1.55;
      font-size: .26rem;
      white-space: pre-line;
      word-break: break-word;
      letter-spacing: .02rem;
      .xy-heading{
        text-align: center;
        font-weight: 700;
        font-size: .3rem;
        color: #fff;
        margin-bottom: .04rem;
        line-height: 1.2;
      }
    }
  }
  .balance{
    width: 3.64rem;
    background: #fff;
    text-align: center;
    padding: .12rem 0;
    margin: .3rem auto 0;
    .text-1{
      font-size: .30rem;
    }
    .text-2{
      font-size: .3rem;
      color: #3690e3;
    }
    .text-3{
      display: inline-block;
      background: #f2616b;
      border-radius: .08rem;
      color: #fff;
      padding: .06rem .14rem;
      margin-left: .16rem;
      line-height: 1;
      font-size: .3rem;
    }
  }
  height: inherit;
  font-size: 0;
  background: linear-gradient(180deg, #f05864,#f2616b);
  overflow-y: scroll;
  .package-list{
    box-sizing: border-box;
    *, *::before, *::after{
      box-sizing: border-box;
    }
    .empty{
      font-size: .36rem;
      color: #fff;
      text-align: center;
    }
    width: 6.9rem;
    margin:.3rem auto;
    .package-section{
      margin-bottom: .5rem;
      .section-title{
        font-size: .34rem;
        color: #fff;
        font-weight: 700;
        margin: 0 0 .22rem;
        padding-left: .08rem;
      }
      &:last-child{
        margin-bottom: 0;
      }
    }
    .package-group{
      margin-bottom: .34rem;
      .group-title{
        font-size: .3rem;
        color: #fff;
        font-weight: 600;
        margin: 0 0 .18rem;
        padding-left: .08rem;
      }
      .group-grid{
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        column-gap: .25rem;
        row-gap: .34rem;
        align-items: start;
      }
    }
    .package-item{
      width: auto;
      padding: .24rem .28rem;
      background: #fff;
      border-radius: .3rem;
      margin-bottom: 0;
      .head{
        .package-title{
          font-size: .32rem;
          color: #000;
          text-align: center;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          white-space: normal;
          line-height: .42rem;
        }
        .price{
          margin-top: .14rem;
          text-align: center;
          white-space: nowrap;
          span{
            color: #f05864;
            font-size: .36rem;
            vertical-align: middle;
          }
          .icon{
            font-size: .2rem;
            border-width: 1px;
            border-style: solid;
            border-radius: 100%;
            display: inline-block;
            width: .2rem;
            height: .2rem;
            text-align: center;
            line-height: .2rem;
            vertical-align: middle;
            margin-right: .06rem;
          }
        }
      }
      &.color1{
        .head{
          .package-title{ color: #4EA6FFFF; }
          .price{
            span{ color: #4EA6FFFF; }
            .icon{ border-color: #4EA6FFFF; }
          }
        }
        .bottom .btn{ background: #4EA6FFFF; }
      }
      &.color2{
        .head{
          .package-title{ color: #F25764FF; }
          .price{
            span{ color: #F25764FF; }
            .icon{ border-color: #F25764FF; }
          }
        }
        .bottom .btn{ background: #F25764FF; }
      }
      &.color3{
        .head{
          .package-title{ color: #FF8A44FF; }
          .price{
            span{ color: #FF8A44FF; }
            .icon{ border-color: #FF8A44FF; }
          }
        }
        .bottom .btn{ background: #FF8A44FF; }
      }
      .desc{
        margin-top: .18rem;
        font-size: .24rem;
        color: #888;
        line-height: .34rem;
        min-height: .68rem; // 2 lines * 0.34rem
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .expire{
        margin-top: .12rem;
        margin-bottom: .08rem;
        text-align: center;
        font-size: .24rem;
        color: #333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 1;
      }
      .bottom{
        margin-top: 0;
        .btn{
          display: block;
          width: 100%;
          color: #fff;
          font-size: .28rem;
          background: #f05864;
          text-align: center;
          height: .52rem;
          line-height: .52rem;
          border-radius: .12rem;
          white-space: nowrap;
        }
      }
    }
  }
  .title{
    font-size: .36rem;
    text-align: center;
    color: #fff;
    padding: .2rem 0 ;
   letter-spacing: .1rem;
  }
  .package-type{
    height: .7rem;
    display: flex;
    background: #fff;
    div{
      flex: 1;
      text-align: center;
      line-height: 1;
      color: #000;
      font-size: .32rem;
      display: inline-block;
      height: .32rem;
      margin-top: .19rem;
    }
    div.active{
      color: #f05864;
    }
    :first-child{
      border-right: 3px solid #000;
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/pages/recharge.vue